export const CLASS_NAME_COMPONENT = "tg-progress";
